// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"2425c942","189":"d1cc6846","216":"04db17c3","236":"79a1f489","260":"83346bcf","281":"0bb7de3a","449":"52f8d70a","533":"73b68aeb","544":"2e963927","566":"dda444ce","722":"bf2a92dc","846":"28a9ac09","940":"e59de39a","962":"0f534e2f","977":"8e97521d"}[chunkId] + ".chunk.js";
};